import styled from 'styled-components';
import { Radio } from 'antd';

export const RadioOptionsWrap = styled.div`
&&& .ant-form-item-control {
  padding-top: 6px;
  line-height: 0;
}
&&& .ant-form-item label{
  font-weight: ${props => props.theme.fontWeight.normal};
}
`
